/**
 * 依頼返却金融機関名取得API
 * リクエスト - リクエスト業務エリア
 */

export interface Sgkd042aRequestDto {
  /** 依頼返却金融機関コード */
  reqretFinancialinstitutioncode?: string;
}
